"use client";

import Swiper, { SwiperSlide } from "@/components/ui/swiper";
import { cn } from "@/lib/utils";

export default function SearchTabs(props: {
  current: string;
  data: {
    tabName: string;
    value: string;
    hide?: boolean;
  }[];
  setCurrent: (current: string) => void;
}) {
  return (
    <div className="relative md:hidden">
      <Swiper
        className="content-box mt-7 w-full !pb-1"
        slidesPerView={"auto"}
        spaceBetween={20}
        loop
        watchSlidesProgress>
        {props.data
          ?.filter((el) => !el.hide)
          .map((el, index) => (
            <SwiperSlide
              key={index}
            onClick={() => props.setCurrent(el.value)}
            className={cn(
              "relative !w-auto py-1.5 text-xs text-[#2C2C2C] transition-all duration-300",
              {
                "font-semibold after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-full after:rounded-lg after:bg-[#2C2C2C]":
                  el.value === props.current,
              }
            )}>
            {el.tabName}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
